import { Pipe, PipeTransform } from '@angular/core';
import { MaskApplierService, MaskPipe } from 'ngx-mask';

@Pipe({
  name: 'phoneNumberExtention'
})
export class PhoneNumberExtentionPipe implements PipeTransform {
  constructor(private maskApplierService: MaskApplierService) {}

  transform(value: number): string {
    if (!value) {
      return '';
    }
    if (value.toString().length > 10) {
      return new MaskPipe(this.maskApplierService).transform(value, '(000) 000-0000 (0000') + ')';
    } else {
      return new MaskPipe(this.maskApplierService).transform(value, '(000) 000-0000');
    }
  }
}
